import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CountryStore {

}

export enum CountryStoreKeys {

}
